/* globals _, CUAC_SETTINGS, DEBUG, PROD, console, module, require */
export const itemsPerPage = 5;
